import {React, styled} from 'common'
import {Controller, useFormContext} from 'react-hook-form'
// import Select from '../Select'
import {FormControl, InputLabel, MenuItem, Select, FormHelperText} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {getDocumentId} from 'utils'

const FormSelect = ({
    name,
    options,
    rules,
    label,
    _defaultValue,
    i18nCategory,
    withTranslation,
    readOnly,
    error,
    ...p
}) => {
    const {control} = useFormContext()
    const {t} = useTranslation()
    return (
        <FormControlStyled error={!!error}>
            <InputLabel htmlFor="uncontrolled-native">{t(`${i18nCategory}.${label}`)}</InputLabel>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({field}) => {
                    const value = getDocumentId(field.value) || ''
                    return (
                        <Select
                            {...field}
                            {...p}
                            value={value}
                            variant="standard"
                            label={t(`${i18nCategory}.${label}`)}
                            disabled={readOnly}>
                            {options &&
                                options?.map((option) => (
                                    <MenuItem
                                        key={`select_${getDocumentId(option)}`}
                                        value={getDocumentId(option)}>
                                        {withTranslation
                                            ? t(`selectOptions.${option?.name || option}`)
                                            : option?.name ?? option}
                                    </MenuItem>
                                ))}
                        </Select>
                    )
                }}
            />
            <FormHelperText>{error?.message && t(`error.${error?.message}`)}</FormHelperText>
        </FormControlStyled>
    )
}

export default FormSelect

const FormControlStyled = styled(FormControl)`
    &.MuiFormControl-root {
        width: 100%;
    }
`
